/** `m:ss` for a time in milliseconds (never negative). */
export function clock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Stars as glyphs; the text for screen readers is separate. */
export function stars(count: number): string {
  return '★'.repeat(count) + '☆'.repeat(3 - count);
}

/** Alarm is kept in tenths of a point: 523 → "52%". */
export function alarmPercent(tenths: number): number {
  return Math.floor(tenths / 10);
}

/** Millions of lire, as the game shows loot. */
export function loot(amount: number): string {
  return String(Math.round(amount));
}
